module.exports = __webpack_public_path__ + "static/media/pet-insurance-icon.b790c604.svg";